export const manifest = {
  screens: {
    scr_4hiihr: { name: "REKOVELLE × Snakker", route: "/", state: {"slide":0}, position: {"x":39360,"y":220} },
    scr_an1eku: { name: "Short. Sharp. Rewarding.", route: "/", state: {"slide":1}, position: {"x":160,"y":4180} },
    scr_b2ks1n: { name: "The Snakker Model", route: "/", state: {"slide":2}, position: {"x":29560,"y":220} },
    scr_5efz5w: { name: "The Journey", route: "/", state: {"slide":3}, position: {"x":47760,"y":220} },
    scr_fl630q: { name: "What Could We Snakify?", route: "/", state: {"slide":4}, position: {"x":49160,"y":220} },
    scr_aqx7nl: { name: "One Experience, Many Channels", route: "/", state: {"slide":5}, position: {"x":2960,"y":220} },
    scr_qclpfx: { name: "Turn Communication into Conversation", route: "/", state: {"slide":6}, position: {"x":50560,"y":220} },
    scr_srlp84: { name: "Every Interaction Creates a Signal", route: "/", state: {"slide":7}, position: {"x":51960,"y":220} },
    scr_7yzgqg: { name: "From Snak to Campaign", route: "/", state: {"slide":8}, position: {"x":42160,"y":220} },
    scr_pui1o4: { name: "From Campaign Data to Learning", route: "/", state: {"slide":9}, position: {"x":53360,"y":220} },
    scr_8xb5u0: { name: "Optional Peer Mode", route: "/", state: {"slide":10}, position: {"x":1560,"y":2200} },
    scr_1qfnhg: { name: "From Asset to Execution", route: "/", state: {"slide":11}, position: {"x":2960,"y":2200} },
    scr_6h2q2t: { name: "Where Could REKOVELLE Benefit?", route: "/", state: {"slide":12}, position: {"x":160,"y":2200} },
  },
  sections: {
    sec_cmsdzd: { name: "Business Proposal Flow", x: 0, y: 0, width: 57520, height: 1180 },
    sec_zf5ksd: { name: "Implementation & Execution", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_f1atcp: { name: "Interactive Demo", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_cmsdzd", children: [
      { kind: "screen", id: "scr_aqx7nl" },
      { kind: "screen", id: "scr_b2ks1n" },
      { kind: "screen", id: "scr_4hiihr" },
      { kind: "screen", id: "scr_7yzgqg" },
      { kind: "screen", id: "scr_5efz5w" },
      { kind: "screen", id: "scr_fl630q" },
      { kind: "screen", id: "scr_qclpfx" },
      { kind: "screen", id: "scr_srlp84" },
      { kind: "screen", id: "scr_pui1o4" },
    ] },
    { kind: "section", id: "sec_zf5ksd", children: [
      { kind: "screen", id: "scr_6h2q2t" },
      { kind: "screen", id: "scr_8xb5u0" },
      { kind: "screen", id: "scr_1qfnhg" },
    ] },
    { kind: "section", id: "sec_f1atcp", children: [
      { kind: "screen", id: "scr_an1eku" },
    ] },
  ],
}
